import ViewReportTemplate from "./component";
import ViewReportTemplateContainer from "./container";

export { ViewReportTemplate, ViewReportTemplateContainer };
export default ViewReportTemplateContainer;



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReports/index.ts